import { Component, OnInit } from '@angular/core';
import { BillingService } from '@app/shared/services/billing/billing.service';
import { IntercomService } from '@app/shared/services/intercom.service';
import { TitleService } from '@app/shared/services/title/title.service';
import { CreditNote } from '../../models/credit_note';
import { GetInvoicesServiceRes, Invoice, LegacyInvoice } from '../../models/invoice';

@Component({
  standalone: false,
  selector: 'sbnb-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.scss'],
})
export class InvoicesComponent implements OnInit {
  invoices: Invoice[];
  legacyInvoices: LegacyInvoice;
  loading: boolean;
  loadingMore: boolean;
  hasMoreEntries: string;
  subscriptionData: any;

  constructor(
    private titleService: TitleService,
    private billingService: BillingService,
    private readonly intercomService: IntercomService
  ) { }

  ngOnInit() {
    this.loading = true;
    this.titleService.manuallySet('Invoices');

    this.checkSubscription();

    this.invoices = [];
    this.loadInvoices();
  }

  checkSubscription() {
    this.billingService.getSubscriptionDetails().subscribe((res) => {
      this.subscriptionData = res;
    });
  }

  downloadFile(file: Invoice | CreditNote) {
    file.downloading = true;

    this.billingService.getDownloadableFile(file.download).subscribe((res) => {
      file.downloading = false;
      if (res.url) {
        window.open(res.url);
      }
    });
  }

  loadInvoices() {
    this.loadingMore = true;
    this.billingService.getInvoices(this.hasMoreEntries).subscribe((res: GetInvoicesServiceRes) => {
      this.invoices = [...this.invoices, ...res.data];

      this.hasMoreEntries = res.meta?.offset;
      this.legacyInvoices = res.meta?.legacy_invoices_url;

      this.loading = false;
      this.loadingMore = false;
    });
  }

  reportProblem() {
    const messageText = `I have a query about a Hospitable invoice`;
    this.intercomService.showNewMessage(messageText);
  }
}
